module.exports = __webpack_public_path__ + "static/media/Palazzo Reale - White - Bordeaux_PWPink.3b68435b.jpg";